import {map} from 'rxjs/operators';
import {launchPoolCache$} from './launchpools-accounts-cache';
import LaunchPoolRaw = lp.LaunchPoolRaw;

export const launchPoolAccounts$ = launchPoolCache$.pipe(
  map((launchPoolCache) => launchPoolCache.toArray<LaunchPoolRaw>())
);
